
<template>
  <div class="main-content-wrapper content-width-1300">
    <ChapterDirectory 
      :chapter-data="chapterData" 
      :current-key="currentKey"
      :can-click="isLogin"
      :directory-title="directoryTitle"
      @handleChange="_directoryChange" 
      @handleLimit="_limit"
      />
    <div 
      v-if="dataList.length"
      class="play-page-right"
      v-loading="listLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
      >
      <div class="play-content">
        <h5-video
          v-if="videoUrl && resourceInfo.resourceId"
          class="h5-video"
          ref="videoWrapper"
          :isTrailer="isTrailer"
          :trailerDuration="trailerDuration"
          :tValue="!isLogin || notFree ? '' : tValue"
          :videoUrl="notFree ? '/student/resourceAuthentication/' + randomData : videoUrl"
          :coverUrl="coverUrl"
          :hadLogo="resourceInfo.hadLogo"
          :level="resourceInfo.level ? resourceInfo.level : (resourceInfo.levelId ? resourceInfo.levelId: 2)"
          :subject="resourceInfo.subjectId"
        ></h5-video>
        <transition name="el-fade-in-linear">
          <div class="not-free" @click.stop v-if="notFree">
            <i class="iconfont iconsuo2"></i>
            <!-- <p class="not-free-line">付费内容，<span class="is-color" @click.stop="_push('purchase')">购买 </span>后才能查看此内容！已购买？<span class="is-color" @click.stop="_push('bind')">立即绑卡</span></p> -->
          </div>
        </transition>
        <div class="play-content-empty" v-if="!dataList.length && !listLoading">
          <img src="../../assets/resource-empty.png" alt class="empty-img" />
          <p>暂无数据~</p>
        </div>
      </div>
      <div class="resource-info">
        <div class="resource-info1">
          <p v-if="resourceInfo.resourceTitle" class="resource-title no-wrap">{{resourceInfo.resourceTitle}}</p>
          <template v-if="isLogin && resourceInfo && resourceInfo.resourceId && ((accountInfo.needBinding && resourceInfo.isFree) || !accountInfo.needBinding)">
            <span v-if="resourceInfo.hasCollect" class="collection-tip float-right" @click.stop="_collection(false)"><i class="iconfont iconshoucang"></i>已收藏</span>
            <span v-else-if="!resourceInfo.hasCollect" class="collection-tip1 float-right" @click.stop="_collection(true)" title="点击收藏"><i class="iconfont iconshoucang1"></i>收藏</span>
          </template>
        </div>
        <div class="resource-info2">
          <!-- <span v-if="resourceInfo.createdBy" class="created-by">{{resourceInfo.createdBy}}</span> -->
          <span class="iconfont iconliulanliang1">{{resourceInfo.playCount ? resourceInfo.playCount : 0}}</span>
          <span v-if="resourceInfo.createdTime" class="created-time iconfont iconshijian-shangchuanshijian">{{resourceInfo.createdTime | formatDateTime1}}</span>
        </div>
        <p v-if="resourceInfo.resourceTitle" class="resource-desc no-wrap" @mouseenter="resourceInfo.description && _descEnter($event)"><span>{{resourceInfo.description ? '视频简介：' : '暂无简介'}}</span>{{resourceInfo.description}}</p>
      </div>
      <div class="related-info">
        <p class="related-title">相关资源</p>
        <div 
          :class="{
            'related-list-box': true,
            'related-list-box-noscroll': noScroll
          }"
          >
          <span
            v-if="noScroll"
            class="pre-btn"
            :class="{'btn-dis': preDis}"
            @click.stop="!preDis && _setPosition('left', 3)"
            >
            <i class="iconfont iconzuo-"></i>
          </span>
          <span
            v-if="noScroll"
            class="next-btn"
            :class="{'btn-dis': nextDis}"
            @click.stop="!nextDis && _setPosition('right', 3)"
            >
            <i class="iconfont iconyou-"></i>
          </span>
          <div class="out-related-list" id="relatedOutList">
            <div class="in-related-list" id="relatedInList">
              <resource-item 
                v-for="item in dataList" 
                :key="item.resourceId" 
                :item="item" 
                component-type="playPage" 
                :class="{
                  'is-select': resourceId === item.resourceId
                }"
                @handleClick="_resourceChange"
                @handleLimit="_limit"
                >
                <span v-if="(accountInfo && accountInfo.needBinding && item.isFree) || (!accountInfo && item.isFree)" class="free-tip" slot="topLeft">试看</span>
                </resource-item>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <div 
      v-else-if="!dataList.length"
      class="play-page-right play-page-right-empty"
      v-loading="listLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)" 
      >
      <div class="resource-list-box empty" v-if="!listLoading">
        <img src="../../assets/resource-empty.png" alt class="empty-img" />
        <p>暂无数据~</p>
      </div>
    </div>
    
    
    <!-- 弹框 -->
    <LimitDialog :visible="operateDialogVisible" @handleClick="_closeDialog" />
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { originUrl } from "config/constant";
import { localStorageUtil, formatDateTime } from "utils/util";
import h5Video from "components/h5video";
import ResourceItem from 'components/resource-item';
import LimitDialog from 'components/limit-dialog';
import ChapterDirectory from "./chapter-directory";
import { reqGetResource } from 'api/play';
import { reqCollectStatus, reqAddHistory, GetDefaultSubjects } from 'api/common';
import { reqGetChapter, reqGetResourceList } from 'api/synchronous-courses';
export default {
  name: 'PlayPage',
  components: {
    ChapterDirectory,
    ResourceItem,
    h5Video,
    LimitDialog
  },
  data() {
    return {
      listLoading: true,
      chapterData: null,
      directoryObj: {},
      resourceId: null,
      currentKey: null,
      videoVisible: true,
      isTrailer: false,
      trailerDuration: 0,
      videoUrl: "",
      coverUrl: "",
      tValue: "bearer " + Cookies.get("mvr_student_Token"),
      imgSrc: originUrl.indexOf('http://localhost:') !== -1
        ? "http://mvr-resource.viewshare.net"
        : originUrl,
      dataList: [],
      resourceInfo: {},
      selectIndex: 0,
      preDis: true,
      nextDis: false,
      noScroll: false,
      descEnter: false,
      directoryTitle: '',
      subjects: null,
      fromType: 'playPage',
      operateDialogVisible: false,
      randomData: 'random' + new Date().getTime(),
      videoStatistics: null,
    };
  },
  filters: {
    formatDateTime1(val) {
      if(!val) {
        return '';
      }
      let dt = new Date(val);
      let str = ""; //存储时间的字符串
      //获取年
      let year = dt.getFullYear();
      //获取月
      let month = dt.getMonth() + 1;
      //获取日
      let day = dt.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    }
  },
  computed: {
    ...mapState(["accountInfo", "isLogin"]),
    notFree() {
      if(this.resourceInfo.resourceId && !this.resourceInfo.canPlay && this.isLogin) {
        return true;
      }else {
        return false;
      }
    },
    showFree(item) {
      if(this.resourceInfo.componentType == 'homeHot' || this.resourceInfo.componentType === 'homeNew') {
        return false;
      }else if(this.dataList.length && this.accountInfo && this.accountInfo.needBinding && item.isFree) {
        return true;
      }else {
        return false;
      }
    }
  },
  methods: {
    _closeDialog(flag = true) {
      this.operateDialogVisible = flag;
    },
    /**
     * 未登录/未绑卡时的提示
     * **/
    _limit(data) {
      this.operateDialogVisible = true;
    },
    _operateDialogOk(type) {
      this._operateDialogClose();
      if(type === 'bind') {
        this.$router.push('/binding-card');
      }else if(type === 'login') {
        this.$router.push('/home-page');
      }else if(type === 'register') {
        this.$router.push('/register');
      }else if(type === 'purchase') {
        let routeUrl = this.$router.resolve({
          path: "/purchase/product-details",
          query: {
            productId: 1
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    /**
     * 关闭操作弹框
     * **/
    _operateDialogClose() {
      this.operateDialogVisible = false;
    },

    /**
     * 左侧目录change
     * **/
    _directoryChange(data) {
      if(!data) {
        return this.listLoading = false;
      }
      // console.log('----change', data);
      this.resourceId = null;
      this.directoryObj = Object.assign({}, this.directoryObj, data);
      this.currentKey = this.directoryObj.chapterThreeId ? this.directoryObj.chapterThreeId : (this.directoryObj.chapterTwoId ? this.directoryObj.chapterTwoId : this.directoryObj.chapterOneId);
      this._getDataList('change');
    },
    _push(type) {
      if(type === 'bind') {
        this.$router.push('/binding-card');
      }else if(type === 'purchase') {
        let routeUrl = this.$router.resolve({
          path: "/purchase/product-details",
          query: {
            productId: 1
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    /**
     * 鼠标移入简介
     * **/
    _descEnter(e) {
      // return;
      if(this.descEnter || !e.target) {
        return;
      }
      this.descEnter = true;
     
      let _w = $(e.target).width();
      let _h = $(e.target).height();
      let $c = $(e.target).clone().css({width: _w, fontSize: '14px', lineHeight: '24px',visibility: 'hidden'}).appendTo('body');
      $c.removeClass('no-wrap');
      $(e.target).removeClass('no-wrap');
      if($c.height() > _h) {
        $(e.target).animate({
          height: $c.height()
        }, function() {
        });
      }
      $c.remove();
    },
    /**
     * 收藏 取消收藏
     * **/
    _collection() {
      let obj = {
        subjectId: this.directoryObj.subjectId,
        editionId: this.directoryObj.editionId,
        volumeId: this.directoryObj.volumeId,
        resourceId: this.resourceInfo.resourceId
      };
      if(this.directoryObj.chapterOneId) {
        obj.chapterOneId = this.directoryObj.chapterOneId;
        if(this.directoryObj.chapterTwoId) {
          obj.chapterTwoId = this.directoryObj.chapterTwoId;
          if(this.directoryObj.chapterThreeId) {
            obj.chapterThreeId =this. directoryObj.chapterThreeId;
          }
        }
      }
      return reqCollectStatus(obj)
        .then(res => {
          if (res.code === 0) {
            this.resourceInfo.hasCollect = !this.resourceInfo.hasCollect;
            let _index = this.dataList.findIndex(ele => ele.resourceId === this.resourceInfo.resourceId);
            this.dataList[_index].hasCollect = this.resourceInfo.hasCollect;
            this.dataList = [...this.dataList];
            this.$message({
              type: 'success',
              message: this.resourceInfo.hasCollect ? "收藏成功~" : "已取消收藏~",
              duration: 2000
            });
          } else {
            this.$message({
              type: "error",
              message: this.resourceInfo.hasCollect ? "取消收藏失败~" : "收藏失败~",
              duration: 2000
            });
          }
        })
        .catch(err => {
          console.log("收藏/取消收藏失败", err);
        });

    },
    /**
     * 新增历史记录
     * **/
    _history(item) {
      if(!this.isLogin && item.componentType !== 'homeHot' && item.componentType !== 'homeNew') {
      // if(!this.isLogin) {
        return;
      }
      let obj = {
        subjectId: this.directoryObj.subjectId,
        editionId: this.directoryObj.editionId,
        volumeId: this.directoryObj.volumeId,
        resourceId: item.resourceId
      };
      if(this.directoryObj.chapterOneId) {
        obj.chapterOneId = this.directoryObj.chapterOneId;
        if(this.directoryObj.chapterTwoId) {
          obj.chapterTwoId = this.directoryObj.chapterTwoId;
          if(this.directoryObj.chapterThreeId) {
            obj.chapterThreeId =this. directoryObj.chapterThreeId;
          }
        }
      }
      return reqAddHistory(obj)
        .then(res => {
          if (res.code === 0) {
          
          } else {
            console.log("新增历史记录失败", res);
            // this.$message({
            //   type: "error",
            //   message: this.resourceInfo.hasCollect ? "取消收藏失败" : "收藏失败",
            //   duration: 2000
            // });
          }
        })
        .catch(err => {
          console.log("新增历史记录失败", err);
        });

    },
    /**
     * 获取章节
     * **/
    _getChapter(type) {
      let obj = {
        subjectId: this.directoryObj.subjectId,
        editionId: this.directoryObj.editionId,
        volumeId: this.directoryObj.volumeId,
      };
      return reqGetChapter(obj).then(res => {
        if(res.code === 0) {
          this.chapterData = res.data;
          if(type === 'treeDataChange') {
            if(this.directoryObj.chapterThreeId) {
              this.currentKey = this.directoryObj.chapterThreeId;
            }else if(this.directoryObj.chapterTwoId) {
              this.currentKey = this.directoryObj.chapterTwoId;
            }else if(this.directoryObj.chapterOneId) {
              this.currentKey = this.directoryObj.chapterOneId;
            }
          }
        } else if(res.code === 14001) {
          if(!this.operateDialogVisible) {
            this.operateDialogVisible = true;
          }
        } else {
          this.$message({
            type: 'error',
            message: '章节目录获取失败',
            duration: 2000
          });
          console.log(res);
        }
      }).catch(err => {
        console.log('章节目录获取失败', err);
      });
    },
    /**
     * 获取数据
     * **/
    _getDataList(type) {
      this.listLoading = true;
      let obj = {
        pageSize: 999,
      }
      return reqGetResourceList(Object.assign(this.directoryObj, obj))
        .then(res => {
          this.listLoading = false;
          if (res.code === 0) {
            this.dataList = res.data.datas;
            this.pageTotal = res.data.totalCount;
            $("#relatedInList").css({ "margin-left": 0 });
            this._relatedInit('init');
            if(!this.dataList.length) {
              this.resourceInfo = {};
              this._queryChange(this.directoryObj);
              return;
            }else {
              let _isLogin = localStorageUtil.getItem('isLogin');
              let _accountInfo = localStorageUtil.getItem('accountInfo');
              for(let x of this.dataList) {
                // if(!_accountInfo || _accountInfo.needBinding) { // 未登录、已登录未绑卡
                //   console.log(x.resourceId, x.isFree, x.canPlay);
                //   x.canPlay = x.isFree ? true : false;
                // }else { // 已登录已绑卡
                //   x.canPlay = true;
                // }
                if(this.fromType === 'homeHot' || this.fromType === 'homeNew') {
                  if(!_isLogin) { // 未登录
                    if(this.resourceId === x.resourceId) {
                      x.canPlay = true;
                    }else {
                      x.canPlay = false;
                    }
                  }else if(_accountInfo.needBinding) { // 已登录未绑卡
                    if(x.isFree){
                      x.canPlay = true;
                    }else {
                      x.canPlay = false;
                    }
                  }else { // 已登录已绑卡
                    x.canPlay = true;
                  }
                }else {
                  if(!_isLogin) { // 未登录
                    x.canPlay = false;
                    if(x.isFree) {
                      x.canPlay = true;
                    }
                  }else if(_accountInfo.needBinding) { // 已登录未绑卡
                    if(x.isFree) {
                      x.canPlay = true;
                    }else {
                      x.canPlay = false;
                    }
                  }else { // 已登录已绑卡
                    x.canPlay = true;
                  }
                }
              }
            }
            this._resourceChange();
            
          } else if(res.code === 14001) {
            this.dataList = [];
            this.resourceInfo = {};
            this.listLoading = false;
            if(!this.operateDialogVisible) {
              this.operateDialogVisible = true;
            }
          } else {
            this.dataList = [];
            this.resourceInfo = {};
            this.listLoading = false;
            this.$message({
              type: "error",
              message: "数据获取失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.dataList = [];
          this.resourceInfo = {};
          this.listLoading = false;
          console.log("数据获取失败", err);
        });
    },
    /**
     * 点击资源播放
     * **/
    _resourceChange(data) {
      if(data && data.resourceId === this.resourceId) {
        return;
      }
      this.randomData = 'random' + new Date().getTime();
      let _index = this.dataList.findIndex(ele => ele.resourceId === (data ? data.resourceId : this.resourceId));
      if(_index === -1) {
        _index = 0;
      }
      let _lastSelectIndex = this.selectIndex;
      this.selectIndex = _index;
      let _repeat = false;
      if(this.dataList[_index].resourceId === this.resourceInfo.resourceId) {
        _repeat = true;
      }
      this.resourceInfo = Object.assign({}, this.dataList[_index]);
      this.resourceInfo.componentType = this.fromType;
      this.resourceId = this.resourceInfo.resourceId;
      this.directoryObj.subjectId = this.resourceInfo.subjectId;
      this.directoryObj.editionId = this.resourceInfo.editionId;
      this.directoryObj.volumeId = this.resourceInfo.volumeId;
      this.directoryObj.chapterOneId = this.resourceInfo.chapterOneId;
      this.directoryObj.chapterTwoId = this.resourceInfo.chapterTwoId;
      this.directoryObj.chapterThreeId = this.resourceInfo.chapterThreeId;
      this._operateResource(_repeat ? 'repeat' : undefined);
      this._queryChange(this.resourceInfo, data ? false : true);
      if(this.resourceInfo.canPlay) {
        this._history(this.resourceInfo);
      }
      if(data) {
        if(data.componentType === 'homeHot' || data.componentType === 'homeNew') {
          this._getDirectoryTitle();
          // this._getChapter('treeDataChange');
        }
        this._selectIdnex(_index, _lastSelectIndex);
      }else if(_index > 3) {
        this._selectIdnex(_index, 0);
      }
      if(!data && !this.resourceInfo.canPlay) {
        this._limit(this.resourceInfo);
      }
      document.title = this.resourceInfo.resourceTitle + ' - 小山云课';
    },
    /**
     * 修改query
     * **/
    _queryChange(data, scrollTop = true) {
      // console.log('====', data.componentType);
      let _stamp = [];
      _stamp.push(this.directoryObj.subjectId);
      _stamp.push(this.directoryObj.editionId);
      _stamp.push(this.directoryObj.volumeId);
      _stamp.push(data.chapterOneId);
      if(data.chapterTwoId) {
        _stamp.push(data.chapterTwoId);
        if(data.chapterThreeId) {
          _stamp.push(data.chapterThreeId);
        }
      }
      this.$router.push({
        path: "/play",
        query: {
          id: this.resourceId,
          type: data.componentType,
          stamp: _stamp.join('%')
        }
      });
      this.$nextTick(() => {
        if(scrollTop) {
          document.querySelector('.home-wrapper').scrollIntoView({});
        }
        
      });
    },
    /**
     * 处理当前要播放的资源
     * **/
    _operateResource(type) {
      if(this.$refs.videoWrapper) {
        this.$refs.videoWrapper._videoPause();
      } 
      if(type === 'repeat') {
        this.videoUrl = '';
        setTimeout(() => {
          this.resourceId = this.resourceInfo.resourceId;
          this.videoUrl = `/student/resourceAuthentication/${this.resourceInfo.resourceId}`;
          let _index = this.resourceInfo.coverUrl.indexOf('/images/');
          this.coverUrl = this.resourceInfo.coverUrl.substring(_index);
          if(this.resourceInfo.fileUrl && this.resourceInfo.fileUrl.indexOf('.mp4') === this.resourceInfo.fileUrl.length - 4 && this.resourceInfo.fileUrl.indexOf('http') === 0) {
            this.videoUrl = this.resourceInfo.fileUrl;
          }
        }, 100);
      }else {
        this.resourceId = this.resourceInfo.resourceId;
        this.videoUrl = `/student/resourceAuthentication/${this.resourceInfo.resourceId}`;
        let _index = this.resourceInfo.coverUrl.indexOf('/images/');
        this.coverUrl = this.resourceInfo.coverUrl.substring(_index);
        if(this.resourceInfo.fileUrl && this.resourceInfo.fileUrl.indexOf('.mp4') === this.resourceInfo.fileUrl.length - 4 && this.resourceInfo.fileUrl.indexOf('http') === 0) {
          this.videoUrl = this.resourceInfo.fileUrl;
        }
      }
      // this.resourceInfo.description = "综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落综合性学习 文学部落";
    },
    /**
     * 相关资料是否左右滑动初始化
     * **/
    _relatedInit(type) {
      this.$nextTick(() => {
        let _wTotal = 0;
        $("#relatedInList .resource-item").each(function(e) {
          _wTotal += $(this).outerWidth(true) + 1;
        });
        $("#relatedInList").width(_wTotal);
        let _w1 = $("#relatedOutList").width();
        if (_wTotal > _w1) {
          this.noScroll = true;
          this.preDis = true;
          this.nextDis = false;
          $("#relatedInList").css({ "margin-left": 0 });
        } else {
          this.noScroll = false;
          let _marL = parseInt(
            $("#relatedInList").css("margin-left").replace("px", "")
          );
          let wrapW = $("#relatedOutList").width();
          let allW = $("#relatedInList").width();
          if (Math.abs(_marL) < 4) {
            this.preDis = true;
          } else {
            this.preDis = false;
          }
          if (Math.abs(Math.abs(_marL) + wrapW - allW) < 4) {
            this.nextDis = true;
          } else {
            this.nextDis = false;
          }
        }
      });
    },

    /**
     * @desc 设置缩略列表位置移动
     * @param type 上left 下right
     * @param num 每次移动的个数 默认5个
     * @param select 点击某一个 默认false
     * **/
    _setPosition(type, num = 5, select = false) {
      let isAnimate = true;
      let itemW = $("#relatedInList .resource-item").eq(0).outerWidth(true);
      if (
        this.lastClickTime &&
        new Date().getTime() - this.lastClickTime < 400
      ) {
        // animate的默认动画时间是400毫秒，如果连续点击的时间小于400毫秒，则此次左右滑动就无需动画了
        isAnimate = false;
      }
      this.lastClickTime = new Date().getTime();

      let wrapW = $("#relatedOutList").width(); // 放缩略图的盒子的宽度
      let listEle = $("#relatedInList");
      let allW = listEle.width(); // 所有缩略图的宽度
      let allML = parseInt(listEle.css("margin-left").replace("px", "")); // 缩略图的margin-left
      if (allW <= wrapW) {
        return;
      } // 如果所有缩略图的宽度还没有放缩略图的盒子宽的话 左右按钮都没用
      if (type === "left") {
        // 点击上一个---margin-left变大
        if (allML >= 0) {
          return;
        } // 如果margin-left大于0的话，说明没有必要再往右去了
        let compute = allML + itemW * num; // 计算往右以后margin-left的宽度
        if (compute >= 0) {
          // 如果计算后的margin-left大于0，说明没有必要再往右去了
          compute = 0;
        }
        // 如果点击的是具体的某一个，所有右移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.selectIndex * itemW + 20;
          if (Math.abs(compute - wrapW) < l) {
            compute = -l + 20 + itemW;
          }
        }

        listEle.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {}
        );
        if (Math.abs(compute) < 4) {
          this.preDis = true;
        } else {
          this.preDis = false;
        }
        if (Math.abs(Math.abs(compute) + wrapW - allW) < 4) {
          this.nextDis = true;
        } else {
          this.nextDis = false;
        }
        return;
      }
      if (type === "right") {
        // 点击下一个---margin-left变小
        if (allW + allML < wrapW) {
          return;
        } // 如果所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
        let compute = allML - itemW * num; // 计算往左以后margin-left的宽度
        if (allW + compute < wrapW) {
          // 如果计算后的所有缩略图的宽度和margin-left加起来小于放缩略图的盒子的话，说明没有必要再往左去了
          compute = -(allW - wrapW);
        }
        // 如果点击的是具体的某一个，所有左移的距离 大于 当前位置距离父元素的左间距，则margin-left的值等于当前位置距离父元素的左间距
        if (select) {
          let l = this.selectIndex * itemW + 20;
          if (Math.abs(compute) > l || Math.abs(compute + wrapW) > l) {
            compute = -l + 20;
          }
        }
        listEle.animate(
          { "margin-left": compute + "px" },
          isAnimate ? 400 : 0,
          () => {}
        );
        if (Math.abs(compute) < 4) {
          this.preDis = true;
        } else {
          this.preDis = false;
        }
        // if (Math.abs(Math.abs(compute) + wrapW - allW) < 4) {
        if (allW - Math.abs(compute) -wrapW < 4) {
          this.nextDis = true;
        } else {
          this.nextDis = false;
        }
      }
    },
    
    /**
     * 点击某一个的初始化
     * **/
    _selectIdnex(index, oldIndex = null) {
      this.selectIndex = oldIndex === null ? this.selectIndex : oldIndex;
      let deff = Math.abs(this.selectIndex - index);
      if (this.selectIndex > index) {
        this.selectIndex = index;
        this.$nextTick(() => {
          this._setPosition("left", deff, true);
        });
      } else {
        this.selectIndex = index;
        this.$nextTick(() => {
          this._setPosition("right", deff, true);
        });
      }
    },
    
    /**
     * 获取科目版本册别名称
     * **/
    _getDirectoryTitle() {
      let _subjects = localStorageUtil.getItem('subjects');
      // console.log('????', this.directoryObj.editionId,_subjects[this.directoryObj.subjectId].editions);
      let _subjectName = _subjects[this.directoryObj.subjectId].subjectName;
      let _editionName = _subjects[this.directoryObj.subjectId].editions[this.directoryObj.editionId].editionName;
      let _volumeName = '';
      let _find = _subjects[this.directoryObj.subjectId].editions[this.directoryObj.editionId].volumes.find(ele => ele.volumeId === this.directoryObj.volumeId);
      if(_find) {
        _volumeName = _find.volumeName;
      }
      this.directoryTitle = `${_subjectName}${_editionName}/${_volumeName}`
    },
    
    /**
     * 初始化参数处理
     * **/
    async _getQuery() {
      let _query = this.$route.query;
      this.resourceId = Number(_query.id);
      this.fromType = _query.type ? _query.type : 'synchronous';
      let _stamp = _query.stamp;
      _stamp = _stamp.split('%');
      if(_stamp && _stamp.length >= 3) {
        this.directoryObj.subjectId = Number(_stamp[0]);
        this.directoryObj.editionId = Number(_stamp[1]);
        this.directoryObj.volumeId = Number(_stamp[2]);
        if(_stamp[3]) {
          this.directoryObj.chapterOneId = Number(_stamp[3]);
          if(_stamp[4]) {
            this.directoryObj.chapterTwoId = Number(_stamp[4]);
            if(_stamp[5]) {
              this.directoryObj.chapterThreeId = Number(_stamp[5]);
            }
          }
        }
        if(localStorageUtil.getItem('subjects')) {
          this._getDirectoryTitle();
        }else {
          GetDefaultSubjects().then(res => {
            this._getDirectoryTitle();
          });
        }
      }
      await Promise.all([this._getChapter(), this._getDataList('init')]);
      if(_stamp[5]) {
        this.currentKey = _stamp[5];
      }else if(_stamp[4]) {
        this.currentKey = _stamp[4];
      }else if(_stamp[3]) {
        this.currentKey = _stamp[3];
      }
    }
  },
  created() {
    this._getQuery();
  }
};
</script>
<style lang="less" scoped>
.main-content-wrapper {
  padding-top: 20px;
  padding-bottom: 0 !important;
}
</style>
<style lang="less">
@color-main: #03B2B2;
.main-content-wrapper {
  .play-page-right {
    min-height: calc(100vh - 110px - 70px);
    width: 984px;
    border-radius: 6px;
    margin-bottom: 20px;
    // background: #fff;
    display: inline-block;
    vertical-align: top;
    .play-content {
      width: 100%;
      height: 554px;
      background: rgba(220, 227, 225, .5);
      position: relative;
      .video-div-box {
        background-image: url('../../assets/image-placeholder-2x.png');
        background-repeat: no-repeat;
        background-position: center;
        box-shadow: 0 0 4px 0px #f2f2f2;
      }
      .not-free {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 3;
        background: rgba(0, 0, 0, 0.4);
        text-align: center;
        .iconfont {
          display: inline-block;
          color: #fff;
          font-size: 60px;
          margin-top: 250px;
        }
        .not-free-line {
          font-size: 16px;
          line-height: 16px;
          margin-top: 10px;
          color: #fff;
          .is-color {
            color: #419EFF;
            cursor: pointer;
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
      .play-content-empty {
        z-index: 4;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        p {
          text-align: center;
          height: 40px;
          line-height: 40px;
          color: #999;
        }
      }
    }
    .resource-info {
      width: 100%;
      min-height: 92px;
      background: #fff;
      padding: 14px 30px;
      .resource-info1 {
        padding-bottom: 12px;
        .resource-title {
          width: 85%;
          font-size: 20px;
          font-weight: bold;
          color: #4A4A4A;
          line-height: 28px;
          display: inline-block;
        }
        .collection-tip {
          cursor: pointer;
          margin-top: 6px;
          .iconfont {
            padding-right: 4px;
            color: @color-main;
          }
        }
        .collection-tip1 {
          cursor: pointer;
          margin-top: 6px;
          .iconfont {
            padding-right: 4px;
          }
          &:hover {
            color: @color-main;
          }
        }
      }
      .resource-info2 {
        height: 26px;
        color: #999999;
        .iconfont {
          display: inline-block;
          &.iconliulanliang1 {
            width: 110px;
          }
          font-size: 14px;
          &:before {
            padding-right: 6px;
          }
        }
       
      }
      .resource-desc {
        color: #717171;
        height: 24px;
        line-height: 24px;
        word-break:break-all;
        overflow: hidden;
        span {
          font-weight: bold;
          // text-shadow: 0 0 1px #717171;
        }
      }
    }
    .related-info {
      .related-title {
        font-size: 16px;
        color: #646464;
        padding-top: 40px;
        padding-bottom: 14px;
      }
      .related-list-box {
        width: 100%;
        height: 226px;
        background: #D3F0F0;
        padding: 14px 30px 20px;
        position: relative;
        .pre-btn {
          cursor: pointer;
          position: absolute;
          top: 100px;
          left: 8px;
          color: @color-main;
          &:hover {
            opacity: 0.8;
          }
        }

        .next-btn {
          cursor: pointer;
          position: absolute;
          top: 100px;
          right: 6px;
          color: @color-main;
          &:hover {
            opacity: 0.8;
          }
        }

        .btn-dis {
          color: #c2c2c2;
          cursor: not-allowed;
          &:hover {
            opacity: 1;
          }
        }
        .out-related-list {
          width: 100%;
          overflow: hidden;
          .in-related-list {
            height: 100%;
            white-space: nowrap;
            margin-left: 0;
            .resource-item {
              width: 200px;
              height: 186px;
              border-radius: 6px;
              border: 3px solid #DCE3E1;
              margin-top: 6px;
              margin-bottom: 0 !important;
              &:not(:last-of-type) {
                margin-right: 26px !important;
              }
              &:hover {
                border-color: @color-main;
              }
              .resource-item-top {
                height: 111px;
                .el-image .image-slot .image-slot-placeholder {
                  width: 150px;
                  height: 34px !important;
                }
                
                .resource-duration {

                }
              }
              .resource-item-title {
                margin: 12px 0;
                padding: 0 13px;
                font-size: 14px;
                font-weight: normal;
                height: 40px;
                line-height: 20px;
                white-space: normal;
              }
              .resource-bottom-box {
                display: none;
              }
              &.is-select {
                border-color: @color-main;
                .resource-item-title {
                  color: @color-main;
                }
              }
            }
          }
        } 
      }
    }
  }
  .play-page-right-empty {
    // min-height: calc(100vh - 110px - 70px);
    position: relative;
    .empty {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      p {
        text-align: center;
        height: 40px;
        line-height: 40px;
        color: #999;
      }
    }
  }
}

</style>